module.exports = __webpack_public_path__ + "assets/img/2.5d769c2a.png";